import { Box, Divider } from "@mui/material"
import { styled } from "@mui/material/styles"
import { MuiOtpInput } from "mui-one-time-password-input"
import { colors } from "../../../theme/colors"

export const ContentContainer = {
  display: "flex",
  flexDirection: "column",
  margin: "0 auto",
  width: "100%",
  position: "relative",
  "& a": {
    color: "#357BF7",
  },
}

export const LogoContainer = {
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  textAlign: "center",
  mb: 4,
}

export const PhoneInput = {
  mb: 3,
  "& .MuiInputBase-root": {
    borderRadius: 2,
    bgcolor: "grey.100",
  },
}

export const ConfirmContainer = {
  display: "flex",
  alignItems: "flex-start",
}

export const AuthTitle = {
  marginBottom: "20px",
  maxWidth: 250,
}

export const AuthSubtitle = {
  marginBottom: "50px",
  maxWidth: 250,
  fontWeight: 400,
}

export const CodeTitle = {
  marginBottom: "50px",
}

export const StyledMuiOtp = styled(MuiOtpInput, {
  shouldForwardProp: (props) => props !== "error",
})(({ error }: { error?: boolean }) => ({
  width: "288px",
  marginBottom: "16px",
  columnGap: "16px",
  "& .MuiInputBase-root": {
    "&::before": {
      borderColor: error ? "red" : "",
    },
    "&::after": {
      borderBottom: error ? "2px solid red" : "",
    },
  },
}))

export const RepeatCodeTitle = {
  fontWeight: 400,
}

export const ChangeNumberContainer = {
  width: "100%",
  margin: "auto 0 0 0",
  border: "1px solid",
  borderRadius: "8px",
  padding: "16px 0",
  borderColor: colors.paleGray,
}

export const ResendText = {
  display: "contents",
  fontSize: "15px",
  whiteSpace: "pre-line",
}

export const ChangeNumberText = {
  display: "contents",
  fontSize: "15px",
}

export const IconContainer = styled(Box)({
  width: "100%",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  marginTop: "auto",
})

export const StyledDivider = styled(Divider)({
  color: colors.darkGrey,
  marginTop: 60,
  marginBottom: 20,
  border: "3px dotted",
  borderTop: "none",
})
